// pages/LogoutPage.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../contexts/AuthProvider";


export default function LogoutPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Remove o token do localStorage
    logout();
    // Redireciona para a página de login
    navigate('/login');
  }, [navigate]);

  return null;
}